export const UPDATE_MENU = "UPDATE_MENU";

export const UPDATE_MENUDETAIL = "UPDATE_MENUDETAIL";
